import ApplicationDevelopment from '../assets/Services/applicationdevelopment.avif'
import Commerce from '../assets/Services/e-commerce.avif'
import StaffAugmentation from '../assets/Services/staffaugmentation.avif'
import SoftwareAuditing from '../assets/Services/softwareauditing.avif'
import Integrations from 'src/assets/Services/Integrations.avif'
import {
    animationVariantsRightSuccess,
    animationVariantsSuccess,
} from 'src/theme/animations/swipeIn'
import { useTranslations } from 'src/provider/LocaleProvider'
import { ServicesLabels } from 'src/types'

export function ServicesLabels() {
    const t = useTranslations()
    const ContentOltServices: ServicesLabels[] = [
        {
            id: 1,
            title: `${t('services.softwareDevelopment.title')}`,
            image: ApplicationDevelopment,
            animationImage: animationVariantsRightSuccess,
            animationText: animationVariantsSuccess,
            address: true,
            typography: `${t('services.softwareDevelopment.content')}`,
        },
        {
            id: 2,
            title: `${t('services.eCommerce.title')}`,
            animationImage: animationVariantsSuccess,
            animationText: animationVariantsRightSuccess,
            image: Commerce,
            address: false,
            typography: `${t('services.eCommerce.content')}`,
        },
        {
            id: 3,
            title: `${t('services.staffAugmentation.title')}`,
            image: StaffAugmentation,
            animationImage: animationVariantsRightSuccess,
            animationText: animationVariantsSuccess,
            address: true,
            typography: `${t('services.staffAugmentation.content')}`,
        },
        {
            id: 4,
            title: `${t('services.softwareAudit.title')}`,
            image: SoftwareAuditing,
            animationImage: animationVariantsSuccess,
            animationText: animationVariantsRightSuccess,
            address: false,
            typography: `${t('services.softwareAudit.content')}`,
        },
        {
            id: 5,
            title: `${t('services.integrations.title')}`,
            image: Integrations,
            animationImage: animationVariantsRightSuccess,
            animationText: animationVariantsSuccess,
            address: true,
            typography: `${t('services.integrations.content')}`,
        },
    ]
    return { ContentOltServices }
}
